module.exports = __webpack_public_path__ + "img/张北牧业.31963e6c.jpg";